import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

export const ttDrawerAnimations: {
  readonly transformDrawer: AnimationTriggerMetadata;
} = {
  transformDrawer: trigger('transform', [
    state(
      'open',
      style({
        transform: 'none',
        visibility: 'visible',
      }),
    ),
    state(
      'void',
      style({
        visibility: 'hidden',
      }),
    ),
    state(
      'defaultOpen',
      style({
        transform: 'none',
        visibility: 'visible',
      }),
    ),
    state(
      'defaultClose',
      style({
        transform: 'none',
        visibility: 'hidden',
      }),
    ),
    state(
      'openToggle',
      style({
        transform: 'none',
        visibility: 'visible',
      }),
    ),
    state(
      'voidToggle',
      style({
        visibility: 'visible',
      }),
    ),
    state(
      'defaultOpenToggle',
      style({
        transform: 'none',
        visibility: 'visible',
      }),
    ),
    state(
      'defaultCloseToggle',
      style({
        transform: 'none',
        visibility: 'visible',
      }),
    ),
    transition('void <=> open', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
    transition('defaultOpen => open', animate('0ms')),
    transition('defaultClose => void', animate('0ms')),
  ]),
};
